<template>
  <div class="ui-category-body">
    <div class="category-flex">
      <div class="category-sidebar">
        <ul>
          <li class="item" v-for='item in items' v-bind:key="item.id"
            v-on:click='(item.children && item.children.length) ? onItemClick(item) : goProduct(item.id)'
            v-bind:class="{ 'sidbaractive': (currentItem && item.id == currentItem.id), 'noActive': (currentItem && item.id != currentItem.id) }">
            <a>{{ item.value }}</a>
          </li>
        </ul>
      </div>
      <div class="category-content" ref="content" v-if='currentItem && currentItem.children'>
        <ul>
          <li class="item clearfix" v-for='item in currentItem.children' v-bind:key="item.id">
            <a v-on:click='goProduct(item.id)'>{{ item.value }}</a>
            <dl v-for='item_1 in item.children' :key="item_1.id" v-on:click='goProduct(item_1.id)'>
              <!-- <dt><img :src="item_1.goods_image_url" :onerror="errorImg" /></dt>
              <dd>{{ item_1.goods_name }}</dd> -->
              <dt><img v-lazy="item_1.image" :onerror="errorImg" /></dt>
              <dd>{{ item_1.value }}</dd>
            </dl>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { Indicator, Toast } from 'mint-ui'
import { mapState, mapMutations, mapActions } from 'vuex'
import { searchGoodsList } from '../../../api/homesearch'
export default {
  data() {
    return {
      errorImg: 'this.src="' + require('../../../assets/image/no_image.jpg') + '"',
      list: [],
    }
  },
  computed: {
    ...mapState({
      items: state => state.goodsclass.items,
      currentItem: state => state.goodsclass.currentItem
    }),
  },
  created() {
    this.getGoodsclassList()
  },
  methods: {
    ...mapMutations({
      saveCurrentGoodsclassItem: 'saveCurrentGoodsclassItem'
    }),
    ...mapActions({
      fetchGoodsclassList: 'fetchGoodsclassList'
    }),
    getGoodsclassList() {
      if (!(this.items && this.items.length)) {
        Indicator.open()
      }
      this.fetchGoodsclassList().then((response) => {

        // this.getGoodsList(response.result.class_list[0].children[0].id)
        Indicator.close()
      }, (error) => {
        Toast(error.message)
        Indicator.close()
      })
    },
    onItemClick(item) {
      this.saveCurrentGoodsclassItem(item)
      this.$refs.content.scrollTop = 0
      // this.getGoodsList(item.children[0].id)
    },
    goProduct(id) {
      let params = { 'cate_id': id }
      this.$router.push({ 'name': 'HomeGoodslist', 'query': params })
    },
    getGoodsList(id) {
      searchGoodsList({ 'cate_id': id }).then(res => {
        if (res.code == 10000) {
          this.list = res.result.goods_list.slice(0, 6);
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
// 取消scroll滚动条
/deep/::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

.ui-category-body {
  width: 100%;
  -webkit-overflow-scrolling: touch;

  .category-flex {
    background: #fff;
    display: flex;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    width: 100%;
    // position: absolute;
    bottom: 0;
    width: 100%;
    top: $headerHeight;

    .category-sidebar {
      flex-basis: 6rem;
      background-color: #F0F1F5;
      overflow-y: scroll;
      padding-bottom: $footerHeight;
      border-radius: 0 .8rem 0 0;
      margin-top: 1rem;

      ul {
        li {
          display: block;
          padding: 0.5rem 0.25rem;

          a {
            display: inline-block;
            color: $formInputColor;
            // display: -webkit-box;
            // -webkit-box-orient: vertical;
            // -webkit-line-clamp: 1;
            // overflow: hidden;
            font-size: $fontSize;
            // text-align: center;
            line-height: .6rem;
          }
        }

        li.noActive {
          background-color: #F0F2F5;
          border-left: 0.1rem solid transparent;

          a {
            color: $formInputColor;
          }
        }

        li.sidbaractive {
          background-color: #FFFFFF;
          border-left: 0.1rem solid $primaryColor;

          a {
            font-weight: 600;
            color: $primaryColor;
          }
        }
      }
    }

    .category-content {
      width: 100%;
      background-color: #fff;
      overflow: auto;
      margin-bottom: $footerHeight;

      ul {
        box-sizing: border-box;
        padding: 0 0 0 .5rem;
        height: 100%;

        li {
          display: block;
          padding: 0.95rem 0 0;
          cursor: pointer;

          a {
            color: $formInputColor;
            font-size: $h2;
            margin-bottom: 1rem;
            font-weight: 700;
            text-align: left;
            display: block;
          }
        }

        dl {
          display: inline-block;
          width: 12.5%;
          text-align: center;

          dt {
            position: relative;

            img {
              max-width: 3.5rem;
              height: 3.5rem;
              overflow: hidden;
              border-radius: .4rem;
            }
          }

          dd {
            font-size: $fontSize;
            line-height: 1rem;
            height: 1rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-bottom: 0.5rem;
            margin-top: .2rem;
          }
        }
      }
    }
  }
}
</style>
